import { UseCaseRecursoAsync } from "src/views/core/types/UseCaseRecursoAsync";
import { EstadoServidor } from "../entities/EstadoServidor.entity";
import { EstadoServidorRepository } from "../repositories/EstadoServidorRepository";
import { Recurso } from 'lib.common/dist/CleanArch';
import { ErrDevGenerico } from 'lib.common/dist/errorHandler';

export class GetEstadoServidoresUseCase<T_OUT extends EstadoServidor> extends UseCaseRecursoAsync<
    null,
    T_OUT[]> {
    private repository: EstadoServidorRepository<T_OUT>;
    constructor(repository: EstadoServidorRepository<T_OUT>) {
        super();
        this.repository = repository;
    }

    async call(): Promise<Recurso<T_OUT[]>> {
        try {
            return this.repository.getEstadoServidores();
        } catch (error) {
            const errorCapa = new ErrDevGenerico(error as Error);
            return Recurso.fromError<T_OUT[]>(errorCapa);
        }
    }
}